import { render, staticRenderFns } from "./ToothTreatmentTable.vue?vue&type=template&id=ddd59464&scoped=true&"
import script from "./ToothTreatmentTable.vue?vue&type=script&lang=js&"
export * from "./ToothTreatmentTable.vue?vue&type=script&lang=js&"
import style0 from "./ToothTreatmentTable.vue?vue&type=style&index=0&id=ddd59464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd59464",
  null
  
)

export default component.exports